import { render, staticRenderFns } from "./ArrowOutBase.vue?vue&type=template&id=a52edc90&scoped=true&"
import script from "./ArrowOutBase.vue?vue&type=script&lang=ts&"
export * from "./ArrowOutBase.vue?vue&type=script&lang=ts&"
import style0 from "./ArrowOutBase.vue?vue&type=style&index=0&id=a52edc90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a52edc90",
  null
  
)

export default component.exports